import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';

import {
  CtaButton,
  ModalContainer,
  TextInput,
} from '@tassomutuo-backoffice/ui';
import { Lead } from '@tassomutuo-backoffice/types';
import formatMoney, {
  formatNumberWithThousandsSeparator,
  removeThousandSeparator,
} from '../../../utils/formatMoney';

interface IFormInputs {
  loanAmount: string;
  propertyValue: string;
}

interface IProps {
  open: boolean;
  handleClose: () => void;
  lead?: Lead;
  updateLoanValues: (data: IFormInputs) => Promise<void>;
}
const ModalLeadLoanValuesForm = ({
  open,
  handleClose,
  lead,
  updateLoanValues,
}: IProps) => {
  const {
    handleSubmit,
    formState: { errors },
    control,

    reset,
  } = useForm<IFormInputs>({
    defaultValues: {
      loanAmount: lead?.properties.loan_amount
        ? formatNumberWithThousandsSeparator(
            formatMoney(+lead?.properties.loan_amount)
          )
        : '',
      propertyValue: lead?.properties.property_value
        ? formatNumberWithThousandsSeparator(
            formatMoney(+lead?.properties.property_value)
          )
        : '',
    },
  });

  useEffect(() => {
    if (lead) {
      reset({
        loanAmount: lead?.properties.loan_amount
          ? formatNumberWithThousandsSeparator(
              formatMoney(+lead?.properties.loan_amount)
            )
          : '',
        propertyValue: lead?.properties.property_value
          ? formatNumberWithThousandsSeparator(
              formatMoney(+lead?.properties.property_value)
            )
          : '',
      });
    }
  }, [lead]);

  const [isLoading, setIsLoading] = useState(false);

  const onCloseHandler = () => {
    handleClose();
    reset({});
  };

  const onSubmit: SubmitHandler<IFormInputs> = async (data) => {
    try {
      setIsLoading(true);
      await updateLoanValues({
        loanAmount: removeThousandSeparator(data.loanAmount),
        propertyValue: removeThousandSeparator(data.propertyValue),
      });
      onCloseHandler();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalContainer
      open={open}
      handleClose={onCloseHandler}
      title="Aggiorna valori mutuo"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box width="100%" maxWidth="400px">
          <Controller
            control={control}
            name="loanAmount"
            rules={{
              required: 'Campo obbligatorio',
            }}
            defaultValue={
              lead?.properties.loan_amount
                ? formatNumberWithThousandsSeparator(
                    formatMoney(+lead?.properties.loan_amount)
                  )
                : ''
            }
            render={({ field }) => (
              <TextInput
                type="text"
                label="Importo mutuo"
                helperText={errors?.loanAmount?.message}
                error={!!errors?.loanAmount}
                showEuroIcon
                {...field}
                onChange={(e: { target: { value: string } }) =>
                  field.onChange(
                    formatNumberWithThousandsSeparator(e.target.value)
                  )
                }
                value={formatNumberWithThousandsSeparator(field.value)}
              />
            )}
          />
          <Controller
            control={control}
            name="propertyValue"
            rules={{
              required: 'Campo obbligatorio',
            }}
            defaultValue={
              lead?.properties.property_value
                ? formatNumberWithThousandsSeparator(
                    formatMoney(+lead?.properties.property_value)
                  )
                : ''
            }
            render={({ field }) => (
              <TextInput
                type="text"
                label="Valore immobile"
                helperText={errors?.propertyValue?.message}
                error={!!errors?.propertyValue}
                showEuroIcon
                {...field}
                onChange={(e: { target: { value: string } }) =>
                  field.onChange(
                    formatNumberWithThousandsSeparator(e.target.value)
                  )
                }
                value={formatNumberWithThousandsSeparator(field.value)}
              />
            )}
          />

          <Box display="flex" justifyContent="center" mt={4}>
            <CtaButton variant="contained" type="submit" loading={isLoading}>
              SALVA
            </CtaButton>
          </Box>
        </Box>
      </form>
    </ModalContainer>
  );
};

export default ModalLeadLoanValuesForm;
